import { makeStyles } from "@material-ui/core/styles";
import { ANDROID, IOS, ECOMMERCE, SHOPIFY } from "../../../../constants";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  cardTitle: {
    textAlign: "center",
    marginLeft: "10px",
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(20),
  },
  cardContainer: {
    padding: "0px 20px 20px 20px",
    background: theme.palette.common.white,
    margin: "20px 0",
    borderRadius: "8px",
  },
  cardRoot: {
    padding: theme.spacing(0.5, 2),
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "9px",
    width: "100%",
  },
  appCard: {
    display: "flex",
    flexDirection: "row",
  },
  cardLabel: {
    color: theme.palette.common.orange,
    textTransform: "upperCase",
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(13),
    fontStyle: "italic",
  },
  cardValue: {
    color: theme.palette.primary.light,
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightMedium,
  },
  large: {
    width: "74px",
    height: "74px",
  },
  iconStyles: {
    width: "40px",
    height: "40px",
  },
  [ANDROID]: {
    width: "74px",
    height: "74px",
    backgroundColor: "#00bc6b",
  },
  [ECOMMERCE]: {
    width: "74px",
    height: "74px",
    backgroundColor: "#17a2b8",
  },
  [IOS]: {
    width: "74px",
    height: "74px",
  },
  [SHOPIFY]: {
    width: "74px",
    height: "74px",
    backgroundColor: "#022f40",
  },
  centerCircular: {
    margin: "auto",
    marginTop: "30%",
  },
  newAppCircular: {
    margin: "auto",
    marginTop: "80px",
    marginBottom: "70px",
  },
  dialogBoxHead: {
    backgroundColor: theme.palette.primary.dark,
  },
  closeIcon: {
    color: theme.palette.text.secondary,
  },
  shopIcon: {
    width: "40px",
    height: "40px",
  },
  appleIcon: {
    color: theme.palette.grey[300],
  },
  androidIcon: {
    color: theme.palette.secondary.main,
  },
  shopifyIcon: {
    color: theme.palette.secondary.light,
  },
  formDialog: {
    overflow: "hidden",
    paddingBottom: 50,
  },
  squareIcon: {
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,
    "& svg path": {
      fill: theme.palette.common.white,
    },
  },
  newAppFormButtons: {
    marginTop: theme.spacing(2),
    "&>button": {
      marginLeft: theme.spacing(2),
    },
  },
  editAppFormButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  newAppFormButton: {
    margin: 7,
  },
  deleteAppFormButton: {
    margin: 7,
  },
  doubleFormField: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "50%",
  },
  marginLeft: {
    marginLeft: "0.5em",
  },
  deleteIcon: {
    color: "#FF6767",
  },
  formSlider: {
    width: "25%",
    margin: 10,
  },
  colorWhite: {
    color: theme.palette.background.default,
  },
  loader: {
    margin: 0,
    marginRight: "10px",
  },
  squareCreateButton: {
    border: "1px solid #08406625",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.buttonPrimary.main,
      color: theme.palette.common.white,
      "& svg path": {
        fill: theme.palette.common.white,
      },
    },
  },
}));
